import { render, staticRenderFns } from "./AdoptionReportPropagandistSchool.vue?vue&type=template&id=1da39190&"
import script from "./AdoptionReportPropagandistSchool.vue?vue&type=script&lang=js&"
export * from "./AdoptionReportPropagandistSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports